// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__264l_","importantInfo":"styles_importantInfo__3IiT1"};